import { IsArray, IsNotEmpty, IsString } from 'class-validator';

export class PutServiceProviderResidentsDto {
  @IsNotEmpty({ each: true })
  @IsArray()
  @IsString({ each: true })
  residentIds!: string[];
}
